<template>
    <div>
      <PendingLiquidations/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import PendingLiquidations from '@/components/EmployeePendingLiquidations.vue'
  
  export default {
    name: 'liquidation-approval-history-view',
    components: {
      PendingLiquidations
    }
  }
  </script>
  